'use client';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { Image } from '@s7/base';
import { Stack, Flex } from '@s7/layout';
import { rem } from '@s7/styles';
import { Typography } from '@s7/ui';
import { AppItem } from '../../../slots/AppItem/AppItem.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var contentSX = {
    maxWidth: rem(304),
    minHeight: rem(408),
    width: "100%",
    position: "relative"
};
var imageSX = function(theme) {
    return {
        width: rem(328),
        height: rem(408),
        left: rem(-64),
        borderRadius: theme.fn.borderRadius(),
        position: "absolute",
        zIndex: 1,
        objectFit: "cover",
        objectPosition: "right top"
    };
};
var MobileFullLayout = function(props) {
    var title = props.title, image = props.image, items = props.items, locale = props.locale, onItemClick = props.onItemClick, _props_renderAppItem = props.renderAppItem, renderAppItem = _props_renderAppItem === void 0 ? AppItem : _props_renderAppItem;
    return /*#__PURE__*/ jsxs(Stack, {
        align: "start",
        spacing: 28,
        sx: {
            zIndex: 1
        },
        children: [
            title && /*#__PURE__*/ jsx(Typography, {
                lineClamp: 2,
                size: "lg1",
                variant: "heading",
                preWrap: true,
                children: title
            }),
            items && items.length && /*#__PURE__*/ jsxs(Stack, {
                sx: contentSX,
                children: [
                    image && /*#__PURE__*/ jsx(Image, {
                        alt: image.title,
                        height: "408",
                        preview: image.preview,
                        src: image.url,
                        sx: imageSX,
                        title: image.title,
                        width: "328"
                    }),
                    /*#__PURE__*/ jsx(Flex, {
                        align: "end",
                        direction: "column",
                        spacing: 16,
                        sx: {
                            marginTop: rem(8),
                            zIndex: 2
                        },
                        children: items.map(function(_param) {
                            var id = _param.id, item = _object_without_properties_loose(_param, [
                                "id"
                            ]);
                            return renderAppItem(_extends({
                                key: id
                            }, item, {
                                locale: locale,
                                compact: true,
                                onClick: function(event) {
                                    return onItemClick == null ? void 0 : onItemClick(_extends({
                                        id: id
                                    }, item), event);
                                }
                            }));
                        })
                    })
                ]
            })
        ]
    });
};

export { MobileFullLayout };
